<template>
  <div class="w-100 d-flex flex-column align-items-center">
    <h-m-styled-plaintext
        v-model="selected"
        :name="name"
        :nav-choices="filterOptions"
        class="mb-3"
    ></h-m-styled-plaintext>
    <h-f-fields
        v-if="selected !== 'interval'"
        :key="calendarKey"
        v-model="date"
        class="w-75"
        input-type="date-no-pop"
        style="transform: translateX(-20px)"
    ></h-f-fields>
    <h-f-fields
        v-else
        :key="calendarKey"
        v-model="date"
        :model-config="modelConfig"
        class="w-75"
        input-type="date-range"
        style="transform: translateX(-20px)"
    ></h-f-fields>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "date-filter",

  props: {
    after: {
      type: String,
    },
    before: {
      type: String,
    },
    name: {
      type: String,
      required: true
    }
  },

  watch: {
    date: function () {
      this.formatDateFilter();
    },

    selected: function () {
      this.formatDateFilter();
    },

  },

  data() {
    return {
      filterOptions: [
        {text: "Avant le", link: "before", active: false},
        {text: "Après le", link: "after", active: false},
        {text: "Égal à", link: "equal", active: false},
        {text: "Intervalle", link: "interval", active: false},
      ],
      selected: "before",
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
      date: new Date(),
      calendarKey: 0,
    }
  },

  async mounted() {
    await this.$nextTick();
    if (this.before || this.after) {
      if (this.selected === 'before') {
        this.date = new Date(this.before);
      } else if (this.selected === 'after') {
        this.date = new Date(this.after)
      } else if (this.selected === "equal") {
        this.date = new Date(this.after);
      } else if (this.selected === "interval") {
        this.date.start = this.after;
        this.date.end = this.before;
      }
      this.calendarKey++;
    }
  },

  methods: {
    async formatDateFilter() {
      await this.$nextTick();
      if (this.selected === 'before') {
        this.updateBefore();
        this.updateAfter(true)
      } else if (this.selected === 'after') {
        this.updateBefore(true);
        this.updateAfter();
      } else if (this.selected === 'equal') {
        this.updateBefore();
        this.updateAfter();
      } else if (this.selected === 'interval') {
        this.$emit('update:before', moment(this.date.end).format('YYYY-MM-DD'));
        this.$emit('update:after', moment(this.date.start).format('YYYY-MM-DD'));
      }
    },

    updateBefore(toNull) {
      if (this.before !== moment(this.date).format('YYYY-MM-DD') && !toNull) {
        this.$emit('update:before', moment(this.date).format('YYYY-MM-DD'));
      } else if (this.before !== null && toNull) {
        this.$emit('update:before', null);
      }
    },

    updateAfter(toNull) {
      if (this.after !== moment(this.date).format('YYYY-MM-DD') && !toNull) {
        this.$emit('update:after', moment(this.date).format('YYYY-MM-DD'));
      } else if (toNull) {
        this.$emit('update:after', null);
      }
    },
  }
}
</script>

<style scoped>

</style>